import styled, { keyframes } from "styled-components";

interface IContainerProps {
  criare?: boolean;
  italinea?: boolean;
  animationCounter?: boolean;
}

const shake = keyframes`
  0% { transform: translateX(7px) }
  50% { transform: translateX(-7px) }
  100% { transform: translateX(0px) }
`;

export const Container = styled.button<IContainerProps>`
  animation: ${(props) => (props.animationCounter ? shake : "unset")} 150ms 2;

  width: 19rem;
  height: 6.2rem;
  position: relative;

  background: ${(props) =>
    props.italinea ? "#153D8A" : props.criare ? "#000000" : "#565656"};

  border-radius: ${(props) => (props.italinea ? "1.4rem" : "unset")};

  color: #ffffff;
  text-align: center;
  font-family: "Galano";
  font-weight: ${(props) => (props.italinea ? "500" : "300")};
  font-size: 1.7rem;
  line-height: 2.3rem;
  letter-spacing: 0.17rem;
  text-transform: uppercase;
  @media (max-width: 1200px) {
    height: fit-content;
    padding: 1.5rem 0;
  }
`;

export const ErrorWrapper = styled.div`
  position: absolute;
  top: -5rem;
  left: -11rem;
`;
